import { Injectable } from '@angular/core';
import { OptionPrice, ProductConfigurationOptionPriceService } from './product-configuration-option-price.service';
import { PriceService } from '../price/price.service';
import { forkJoin, Observable, of, switchMap, first } from 'rxjs';
import { CartRowFeatureOptionSelection, ProductConfiguration } from '../../models/product-configuration-types';
import { CustomerProductPrice } from '../../models/price';
import { Product } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ProductConfigurationPriceTotalService {
  constructor(
    protected optionPriceService: ProductConfigurationOptionPriceService,
    protected priceService: PriceService
  ) {}

  getConfigurationTotalPrice(
    configuration: ProductConfiguration,
    selections: CartRowFeatureOptionSelection[],
    product?: Product
  ): Observable<CpqPrice> {
    const priceQuestions = [];

    for (const selection of selections) {
      priceQuestions.push(this.optionPriceService.getPrice(selection.option).pipe(first()));
    }

    return forkJoin([
      this.priceService
        .getCurrentCustomerPrice(product?.extra?.pim?.configurationTemplate || configuration.id)
        .pipe(first()),
      ...priceQuestions
    ]).pipe(
      switchMap(prices => {
        let configurationPrice: CustomerProductPrice = prices.splice(0, 1)[0];

        let total = prices.reduce((sum, price) => (sum += price.price), 0);
        total += configurationPrice.customerGrossPrice.value;

        const priceMap = new Map<string, OptionPrice>();
        prices.forEach(price => {
          priceMap.set(price.id, price);
        });
        return of({
          basePrice: configurationPrice.customerGrossPrice.value,
          totalPrice: total,
          currency: prices[0]?.currency,
          discountPercentage: configurationPrice.customerDiscountPercent || 0,
          optionPrices: priceMap
        });
      })
    );
  }
}

export interface CpqPrice {
  basePrice: number;
  totalPrice: number;
  currency: string;
  discountPercentage: number;
  optionPrices: Map<string, OptionPrice>;
}
